import React, { useRef } from "react";
import generatePDF from "react-to-pdf";

const SummaryPDF = ({ trades, summary, month }) => {
  const pdfRef = useRef();

  return (
    <div className="pdfMain">
      <div
        ref={pdfRef}
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "210mm", // A4 width for better formatting
          color: "black",
          padding: 20,
          backgroundColor: "#fff",
          pageBreakAfter: "always",
        }}
      >
        <h2>Trade Summary</h2>
        <p className="mb-1">
          <strong>Total Signals:</strong> {summary?.totalSignals}
        </p>
        <p className="mb-1">
          <strong>Wins:</strong> {summary?.wins}
        </p>
        <p className="mb-1">
          <strong>Losses:</strong> {summary?.losses}
        </p>
        <p className="mb-1">
          <strong>Avg Gain:</strong> {summary?.avgGain}%
        </p>

        <p className="mb-1">
          <strong>Win Rate:</strong> {summary?.winRate}
        </p>
        <p className="mb-1">
          <strong>Closed Trades:</strong> {summary?.closedTrades}
        </p>

        <div
          style={{
            backgroundColor: "#ededed",
            borderRadius: "30px",
            padding: "25px 20px",
            marginBottom: "20px",
            textAlign: "left",
            fontSize: "15px",
            color: "#000",
            marginTop: "20px",
          }}
          className="responsive-text"
        >
          <table>
            <tbody>
              {trades.map((val, key) => (
                <tr key={key}>
                  <td style={{ padding: "10px", paddingLeft: 0 }}>
                    <div>
                      <div style={{ fontWeight: "bold" }}>{val?.pair}</div>
                      <div>
                        <span style={{ fontWeight: 500 }}>
                          {val?.gainPercent}%
                        </span>{" "}
                        {val?.result}
                      </div>
                      <div>
                        ({val?.createdAt}, {val?.side})
                      </div>
                    </div>
                  </td>
                  <td style={{ padding: "10px", paddingLeft: 0 }}>
                    <div style={{ fontSize: "14px" }}>
                      <div>Entry:{val?.entryPrice}</div>
                      {val?.tp1 && <div>TP1:{val?.tp1}</div>}
                      {val?.tp2 && <div>TP2:{val?.tp2}</div>}
                      {val?.tp3 && <div>TP3:{val?.tp3}</div>}
                      {val?.stopLoss && <div>SL:{val?.stopLoss}</div>}

                      <div>
                        Outcome:{val?.result == "loss" ? "Not Hit" : "Hit"}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <button
        onClick={() =>
          generatePDF(pdfRef, { filename: `summary(${month}).pdf` })
        }
        className="reset"
      >
        Generate PDF
      </button>
    </div>
  );
};

export default SummaryPDF;
